"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogTitleOverrides = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, spacing = _a.spacing;
    return ({
        root: (_b = {
                padding: spacing(5, 6, 4)
            },
            _b[breakpoints.up("lg")] = {
                paddingLeft: spacing(8),
                paddingRight: spacing(8),
            },
            _b[breakpoints.up("xl")] = {
                paddingLeft: spacing(13),
                paddingRight: spacing(13),
            },
            _b),
    });
};
//# sourceMappingURL=MuiDialogTitle.js.map